import { TemplateColumnCategory } from "@/enums/TemplateColumnCategory";
import { z } from "zod";

export const ReportTemplateColumnSchema = z.object({
  id: z.string(),
  header: z.string(),
  enabled: z.boolean(),
  width: z.number(),
  position: z.number(),
  category: z.nativeEnum(TemplateColumnCategory),
});

export const ReportTemplateSchema = z.object({
  name: z.string(),
  defaultLayout: z.boolean(),
  lockedBy: z.string().nullable().optional(),
  tags: z.string(),
  columns: z.array(ReportTemplateColumnSchema),
});

export const ReportDataSchema = z.object({
  name: z.string(),
  id: z.string(),
  context: z.string(),
  enabled: z.boolean(),
  defaultTemplate: z.string().nullable(),
  templates: z.array(z.string()),
  requireAsOf: z.boolean(),
  requireDateRange: z.boolean(),
  dateFilterOptions: z.array(z.string()),
  requireKeyword: z.boolean(),
  requireProjectStatus: z.boolean(),
  keywordTitle: z.string().nullable().optional(),
  checkWaivers: z.boolean(),
});

export const ReportDataListSchema = z.array(ReportDataSchema);

export const ListOfReportDataSchema = z.object({
  reports: ReportDataListSchema,
});

export const ReportOptionsSchema = z.object({
  projectId: z.string().optional(),
  drawId: z.string().optional(),
  checkingAccountId: z.string().optional(),
  subdivisionId: z.string().optional(),
  templateName: z.string().optional(),
  asOfDate: z.date().optional(),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
  dateFilterOption: z.string().optional(),
  legalSize: z.boolean().optional(),
  includeWaivers: z.boolean().optional(),
  includeChecklists: z.boolean().optional(),
  url: z.string().optional(),
  keyword: z.string().optional(),
  projectStatusList: z.array(z.number()).optional(),
  soldAfter: z.date().optional(),
});

export const ReportTemplatesSchema = z.array(ReportTemplateSchema);

export const ReportTemplateListSchema = z.object({
  templates: ReportTemplatesSchema,
});

export type ReportData = z.infer<typeof ReportDataSchema>;
export type ListOfReportData = z.infer<typeof ListOfReportDataSchema>;
export type ReportOptions = z.infer<typeof ReportOptionsSchema>;
export type ReportTemplateColumn = z.infer<typeof ReportTemplateColumnSchema>;
export type ReportTemplate = z.infer<typeof ReportTemplateSchema>;
export type ReportTemplates = z.infer<typeof ReportTemplatesSchema>;
export type ReportTemplateList = z.infer<typeof ReportTemplateListSchema>;
